import React, { Component } from 'react';
import {Context} from "context";

import styles from 'components/progress/Progress.module.scss';

class Progress extends Component {
    static contextType = Context;

    state = {
        total: 5000,
        progress: 0,
        max: 86
    };

    interval;

    componentDidMount() {
        this.setState({
            max: Math.floor(Math.random() * (99 - 86 + 1)) + 86,
            total: Math.floor(Math.random() * (5000 - 3000 + 1)) + 3000
        }, () => {
            this.countUp();
        })
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    countUp = () => {
        const total = this.state.total;
        const updates = 50;
        const interval = total / updates;
        const averageIncrease = 100 / 50;
        const minIncrease = averageIncrease * 0.1;
        const maxIncrease = averageIncrease * 1.9;

        this.interval = setInterval(() => {
            let progress = this.state.progress + Math.floor(Math.random() * (maxIncrease - minIncrease + 1)) + minIncrease;
            progress = progress > this.state.max ? this.state.max : progress;
            progress = parseInt(progress);

            this.setState({ progress })
        }, interval);
    };

    render() {

        let text = "Fetching project settings...";
        if(this.state.progress > 14) text = "Fetching map pack...";
        if(this.state.progress > 35) text = "Filtering binary data...";
        if(this.state.progress > 50) text = "Grouping map types...";
        if(this.state.progress > 70) text = "Detecting modifications...";
        if(this.state.progress > 82) text = "Preparing workspace...";

        return (
            <div className={`${styles.loading} bgPrimary ${this.context.lightTheme ? "light" : "dark"} app`}>
                <div>
                    <div className={styles.text}>
                        <p>{text}</p>
                        <p>{this.state.progress}%</p>
                    </div>
                    <div className={styles.progress}>
                        <span style={{width: `${this.state.progress}%`}} />
                        <span />
                    </div>
                </div>
            </div>
        )
    }
}

export default Progress;
